import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface Incident { id: string; severity: string; status: string; trigger_type: string; opened_at: string; contained_at?: string; resolved_at?: string; closed_at?: string; rca_status?: string; description?: string; }

export function useIncidents(status?: string) {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [incidents, setIncidents] = useState<Incident[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;

    async function load() {
      try {
        if (!cancelled) setLoading(true);
        const params = status ? `?status=${encodeURIComponent(status)}` : '';
        const res = await fetchJSON<{ incidents?: Incident[] }>(`/api/dashboard/incidents${params}`, token);
        if (!cancelled) { setIncidents(res.incidents || []); setError(null); }
      } catch (e) {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load incidents');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, [token, status, refreshKey, logout]);

  return { incidents, loading, error };
}
